// Get Assignment
export const GET_ASSIGNMENT_REQUEST = 'GET_ASSIGNMENT_REQUEST';
export const GET_ASSIGNMENT_DONE = 'GET_ASSIGNMENT_DONE';
export const GET_ASSIGNMENT_FAILED = 'GET_ASSIGNMENT_FAILED';
